<template>
    <svg
        class="bg"
        width="268"
        height="364"
        viewBox="0 0 268 364"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <rect width="268" height="364" rx="28" fill="#fff" />
        <g filter="url(#filter0_dd_131_4004)">
            <rect x="118" y="250" width="113" height="69" rx="8" fill="#fff" />
        </g>
        <path stroke="#F6F6F9" d="M174.5 250v69" />
        <rect x="204" y="309" width="9" height="3" rx="1.5" fill="#00A367" fill-opacity=".2" />
        <rect x="198" y="308" width="5" height="5" rx="2.5" fill="#00A367" fill-opacity=".2" />
        <rect x="181" y="308" width="15" height="5" rx="2.5" fill="#000" fill-opacity=".1" />
        <rect x="181" y="302" width="20" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="147" y="309" width="9" height="3" rx="1.5" fill="#FF2828" fill-opacity=".2" />
        <rect x="141" y="308" width="5" height="5" rx="2.5" fill="#FF2828" fill-opacity=".2" />
        <rect x="124" y="308" width="15" height="5" rx="2.5" fill="#000" fill-opacity=".1" />
        <rect x="124" y="302" width="20" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <path stroke="#F6F6F9" d="M118 295.5h113" />
        <rect x="204" y="286" width="9" height="3" rx="1.5" fill="#00A367" fill-opacity=".2" />
        <rect x="198" y="285" width="5" height="5" rx="2.5" fill="#00A367" fill-opacity=".2" />
        <rect x="181" y="285" width="15" height="5" rx="2.5" fill="#000" fill-opacity=".1" />
        <rect x="181" y="279" width="20" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="147" y="286" width="9" height="3" rx="1.5" fill="#FF2828" fill-opacity=".2" />
        <rect x="141" y="285" width="5" height="5" rx="2.5" fill="#FF2828" fill-opacity=".2" />
        <rect x="124" y="285" width="15" height="5" rx="2.5" fill="#000" fill-opacity=".1" />
        <rect x="124" y="279" width="20" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <path stroke="#F6F6F9" d="M118 272.5h113" />
        <rect x="204" y="263" width="9" height="3" rx="1.5" fill="#00A367" fill-opacity=".2" />
        <rect x="198" y="262" width="5" height="5" rx="2.5" fill="#00A367" fill-opacity=".2" />
        <rect x="181" y="262" width="15" height="5" rx="2.5" fill="#000" fill-opacity=".1" />
        <rect x="181" y="256" width="20" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="147" y="263" width="9" height="3" rx="1.5" fill="#00A367" fill-opacity=".2" />
        <rect x="141" y="262" width="5" height="5" rx="2.5" fill="#00A367" fill-opacity=".2" />
        <rect x="124" y="262" width="15" height="5" rx="2.5" fill="#000" fill-opacity=".1" />
        <rect x="124" y="256" width="20" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="237" width="94" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="231" width="114" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="225" width="114" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="212" width="45" height="5" rx="2.5" fill="#000" fill-opacity=".1" />
        <g filter="url(#filter1_dd_131_4004)">
            <rect x="118" y="131" width="113" height="68" rx="8" fill="#fff" />
        </g>
        <mask
            id="mask0_131_4004"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="118"
            y="131"
            width="113"
            height="68"
        >
            <rect
                width="113"
                height="68"
                rx="8"
                transform="matrix(-1 0 0 1 231 131)"
                fill="#C4C4C4"
            />
        </mask>
        <g mask="url(#mask0_131_4004)">
            <path
                d="M231 199.5h.5v-47.72h-.5c-.764 0-1.115-.392-1.617-.968l-.003-.004c-.5-.574-1.138-1.307-2.431-1.307-.839 0-1.348.673-1.673 1.322-.335.668-.588 1.54-.824 2.353l-.009.031c-.246.851-.477 1.637-.766 2.215-.302.605-.563.769-.779.769-.404 0-.666-.123-.881-.303-.237-.198-.423-.468-.663-.815l-.007-.009c-.227-.329-.504-.727-.894-1.033-.41-.32-.924-.525-1.606-.525-.663 0-1.158.17-1.553.453-.36.258-.612.594-.815.865l-.025.033c-.222.295-.396.518-.632.681-.22.152-.525.272-1.026.272-.124 0-.254-.05-.406-.211-.161-.17-.321-.44-.477-.815-.312-.751-.546-1.772-.78-2.85-.019-.084-.037-.169-.055-.254-.211-.973-.427-1.972-.707-2.745-.152-.419-.337-.814-.578-1.111-.247-.305-.593-.553-1.048-.553-.491 0-.841.315-1.075.651-.237.34-.423.793-.58 1.285-.3.944-.536 2.178-.766 3.383l-.032.168c-.244 1.28-.486 2.513-.797 3.426-.156.458-.317.796-.479 1.011-.16.213-.267.237-.322.237-.468 0-.771-.1-.999-.232-.242-.14-.429-.329-.667-.575l-.015-.016c-.223-.231-.497-.514-.869-.729-.394-.228-.872-.367-1.5-.367-.773 0-1.297.438-1.662.965-.345.499-.595 1.145-.818 1.721l-.012.033c-.239.616-.45 1.154-.721 1.546-.257.373-.514.534-.838.534-.853 0-1.375.661-1.708 1.319-.344.68-.597 1.567-.831 2.39l-.004.016c-.24.846-.462 1.626-.743 2.2-.296.605-.552.766-.765.766-.278 0-.531-.158-.805-.588-.279-.436-.504-1.034-.752-1.704l-.012-.032c-.234-.631-.492-1.327-.835-1.863-.353-.552-.87-1.049-1.647-1.049-.447 0-.8.222-1.063.516-.255.286-.453.666-.616 1.07-.316.785-.554 1.81-.783 2.789l-.019.084c-.24 1.031-.471 2.004-.77 2.721-.149.359-.3.615-.449.775-.14.151-.252.19-.351.19-.425 0-.688-.129-.896-.312-.233-.205-.41-.485-.641-.849l-.003-.005c-.217-.342-.482-.76-.872-1.081-.411-.338-.936-.551-1.639-.551-.435 0-.725-.161-.969-.421-.266-.284-.471-.678-.703-1.151-.015-.03-.03-.061-.045-.092-.206-.422-.442-.907-.762-1.284-.366-.433-.866-.756-1.572-.756-.782 0-1.294.506-1.64 1.063-.329.532-.576 1.221-.801 1.848l-.024.065c-.242.675-.464 1.278-.745 1.717-.275.429-.537.596-.841.596-.041 0-.144-.017-.305-.246-.16-.229-.317-.588-.468-1.072-.299-.964-.526-2.263-.76-3.61l-.004-.026c-.229-1.317-.466-2.678-.786-3.71-.161-.518-.355-.994-.605-1.35-.249-.355-.616-.672-1.123-.672-.489 0-.856.284-1.115.622-.255.335-.455.781-.62 1.264-.332.969-.578 2.246-.813 3.474l-.01.048c-.236 1.234-.462 2.415-.753 3.294-.148.447-.3.776-.453.983-.152.207-.247.222-.287.222-.327 0-.562-.144-.793-.447-.24-.316-.428-.745-.652-1.255l-.028-.063c-.222-.505-.483-1.088-.862-1.539-.401-.476-.949-.823-1.716-.823-.669 0-1.17.148-1.573.397-.386.24-.65.555-.862.807l-.005.007c-.225.268-.392.465-.619.61-.211.136-.505.244-.992.244-.367 0-.621-.163-.857-.489-.256-.354-.447-.842-.671-1.417l-.004-.01c-.209-.539-.45-1.159-.809-1.638-.383-.511-.925-.896-1.71-.896-.724 0-1.254.255-1.657.644-.374.361-.626.83-.834 1.218l-.006.012c-.226.42-.406.75-.645.99-.214.214-.479.357-.909.357-.358 0-.624-.169-.879-.525-.271-.378-.479-.901-.711-1.503l-.024-.06c-.214-.554-.454-1.176-.787-1.658-.361-.521-.881-.949-1.65-.949-.459 0-.82.23-1.089.537-.262.297-.462.694-.627 1.116-.325.838-.564 1.936-.791 2.982l-.007.029c-.235 1.081-.459 2.105-.752 2.861-.147.378-.297.649-.446.819-.141.161-.249.197-.339.197-.428 0-.692-.128-.9-.307-.232-.199-.408-.471-.639-.827l-.003-.005c-.217-.335-.483-.744-.874-1.058-.411-.33-.934-.537-1.635-.537-.772 0-1.326.361-1.73.849-.384.464-.652 1.064-.88 1.589-.016.037-.032.073-.047.108-.221.511-.409.945-.643 1.268-.235.324-.46.461-.75.461-.69 0-.995-.468-1.506-1.291-.467-.749-1.105-1.763-2.545-1.763-.764 0-1.303.38-1.691.874-.37.471-.632 1.082-.858 1.615l-.013.031c-.235.552-.436 1.024-.69 1.37-.242.331-.484.479-.799.479-.81 0-1.309.574-1.631 1.168-.302.557-.526 1.276-.734 1.943-.014.046-.029.093-.043.138-.231.737-.449 1.402-.739 1.886-.284.473-.566.663-.904.663-.329 0-.601-.186-.874-.672-.279-.496-.483-1.176-.703-1.933l-.021-.069c-.205-.705-.429-1.474-.752-2.068-.337-.62-.859-1.188-1.701-1.188h-.5V199.5H231Z"
                fill="url(#paint0_linear_131_4004)"
                stroke="#006DFF"
            />
        </g>
        <rect x="159" y="190" width="31" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="120" width="45" height="5" rx="2.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="104" width="82" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="98" width="114" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="92" width="114" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="86" width="114" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="74" width="94" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="68" width="114" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="62" width="114" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="56" width="114" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="50" width="114" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <rect x="118" y="36" width="45" height="5" rx="2.5" fill="#000" fill-opacity=".1" />
        <path
            opacity=".1"
            d="M98.4931 69c-.0008 4.0053-.7906 7.9714-2.3242 11.6718-1.5335 3.7005-3.7809 7.0628-6.6137 9.895-2.8327 2.8321-6.1955 5.0788-9.8963 6.6115-3.7007 1.5328-7.667 2.3217-11.6723 2.3217-4.0054 0-7.9713-.7889-11.6714-2.3217-3.7001-1.5327-7.0619-3.7794-9.8935-6.6115-2.8316-2.8322-5.0774-6.1945-6.6094-9.895-1.532-3.7004-2.32-7.6665-2.3192-11.6718.0009-4.0053.7906-7.9714 2.3242-11.6718 1.5336-3.7005 3.7809-7.0628 6.6137-9.895 2.8328-2.8321 6.1956-5.0788 9.8963-6.6115C60.0281 39.2889 63.9944 38.5 67.9997 38.5s7.9712.7889 11.6713 2.3217c3.7001 1.5327 7.0619 3.7794 9.8935 6.6115 2.8316 2.8322 5.0775 6.1945 6.6095 9.895 1.5319 3.7004 2.32 7.6665 2.3191 11.6718h0Z"
            stroke="#FF9500"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M67.9997 38.5c5.4622 0 10.8239 1.4669 15.5248 4.2474 4.701 2.7805 8.5687 6.7725 11.1991 11.5591 2.6305 4.7866 3.927 10.192 3.7543 15.6515-.1728 5.4595-1.8085 10.7728-4.7363 15.3847s-7.0402 8.3532-11.9076 10.833c-4.8674 2.4798-10.3112 3.6071-15.7625 3.2641-5.4514-.343-10.7103-2.1436-15.2273-5.2138-4.5171-3.0703-8.1265-7.2974-10.4511-12.2397"
            stroke="#FF9500"
            stroke-width="3"
            stroke-linecap="round"
        />
        <rect x="58" y="78" width="20" height="3" rx="1.5" fill="#000" fill-opacity=".1" />
        <path
            d="M73.4234 72.2698c-2.898 0-4.752-1.566-4.752-3.69 0-1.44.954-2.646 2.286-3.114-1.224-.45-1.998-1.674-1.998-2.88 0-2.124 1.89-3.618 4.464-3.618 2.592 0 4.482 1.494 4.482 3.618 0 1.188-.774 2.43-2.016 2.88 1.332.468 2.304 1.674 2.304 3.114 0 2.124-1.854 3.69-4.77 3.69Zm0-7.722c1.242-.036 2.016-.792 2.016-1.8 0-.918-.756-1.71-2.016-1.71-1.242 0-1.998.792-1.998 1.71 0 1.008.774 1.764 1.998 1.8Zm0 5.652c1.494 0 2.304-.882 2.304-1.872 0-1.008-.792-1.908-2.304-1.908-1.494 0-2.286.9-2.286 1.908 0 .99.81 1.872 2.286 1.872ZM67.4171 59.5978l-.702 2.016c-.54-.234-1.314-.486-2.142-.486-2.394 0-4.05 1.512-4.302 3.924.468-.792 1.584-1.494 3.186-1.494 2.556 0 4.32 1.656 4.32 4.266 0 2.682-2.142 4.446-4.878 4.446-2.718 0-5.112-1.926-5.112-5.868 0-4.608 2.88-7.434 6.93-7.434 1.17 0 2.16.27 2.7.63Zm-6.894 8.298c0 1.386 1.116 2.268 2.376 2.268 1.296 0 2.394-.864 2.394-2.268 0-1.422-1.116-2.304-2.394-2.304-1.296 0-2.376.882-2.376 2.304Z"
            fill="#FF9500"
        />
        <defs>
            <filter
                id="filter0_dd_131_4004"
                x="116"
                y="249"
                width="117"
                height="74"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feMorphology
                    radius="1"
                    operator="dilate"
                    in="SourceAlpha"
                    result="effect1_dropShadow_131_4004"
                />
                <feOffset />
                <feColorMatrix
                    values="0 0 0 0 0.00784314 0 0 0 0 0.00784314 0 0 0 0 0.0470588 0 0 0 0.04 0"
                />
                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_131_4004" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feMorphology radius="2" in="SourceAlpha" result="effect2_dropShadow_131_4004" />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    values="0 0 0 0 0.00784314 0 0 0 0 0.00784314 0 0 0 0 0.0470588 0 0 0 0.1 0"
                />
                <feBlend in2="effect1_dropShadow_131_4004" result="effect2_dropShadow_131_4004" />
                <feBlend in="SourceGraphic" in2="effect2_dropShadow_131_4004" result="shape" />
            </filter>
            <filter
                id="filter1_dd_131_4004"
                x="116"
                y="130"
                width="117"
                height="73"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feMorphology
                    radius="1"
                    operator="dilate"
                    in="SourceAlpha"
                    result="effect1_dropShadow_131_4004"
                />
                <feOffset />
                <feColorMatrix
                    values="0 0 0 0 0.00784314 0 0 0 0 0.00784314 0 0 0 0 0.0470588 0 0 0 0.04 0"
                />
                <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_131_4004" />
                <feColorMatrix
                    in="SourceAlpha"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feMorphology radius="2" in="SourceAlpha" result="effect2_dropShadow_131_4004" />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="2" />
                <feColorMatrix
                    values="0 0 0 0 0.00784314 0 0 0 0 0.00784314 0 0 0 0 0.0470588 0 0 0 0.1 0"
                />
                <feBlend in2="effect1_dropShadow_131_4004" result="effect2_dropShadow_131_4004" />
                <feBlend in="SourceGraphic" in2="effect2_dropShadow_131_4004" result="shape" />
            </filter>
            <linearGradient
                id="paint0_linear_131_4004"
                x1="174.287"
                y1="146.771"
                x2="174.287"
                y2="194"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#F0F6FF" />
                <stop offset="1" stop-color="#fff" />
            </linearGradient>
        </defs>
    </svg>
</template>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.bg {
    box-shadow: $opteo-shadow-l;
    @include br-28;
}
</style>
